import React, { useContext } from "react";
import { SimpleContext } from "../../../../../store/context/simple-context";
import { MediaAuthContext } from "../../../../../store/context/media-auth-context";
import { PERIODS } from "../../content/index.content";
import parse from "html-react-parser";
import Mark from "./Mark";
import Question from "../../Question";
import "./index.scss";

const TitleTab = ({ mark, text, tooltip, info, period }) => {
  const {
    media: { isNotInitMobile },
  } = useContext(MediaAuthContext);
  const {
    translate: { t },
  } = useContext(SimpleContext);
  const currentMark =
    mark && typeof mark === "string" ? mark : mark[period || PERIODS[1]];
  const currentInfo = info ? info[period] : {};
  return (
    <div className="GP-C-T-T-I-title">
      <Mark mark={currentMark || ""} customClass="GP-C-T-T-I-title__mark" />
      <p className="GP-C-T-T-I-title__text">
        {t(text)}
        {tooltip && <Question tooltip={tooltip} rightView={!isNotInitMobile} />}
      </p>
      {info && (
        <p className="GP-C-T-T-I-title__info">
          {currentInfo?.number && <b>{t(currentInfo.number)}</b>}
          {currentInfo?.normal && parse(t(currentInfo.normal))}
        </p>
      )}
    </div>
  );
};

export default TitleTab;
